import { StatusColorType } from "@/components/atoms/Status/styled";

export const getStatusColor = (stateId: string): StatusColorType => {
    switch (stateId) {
        case "-20":
        case "0":
        case "1":
        case "5":
        case "6":
        case "7":
        case "9":
            return StatusColorType.Success;
        case "2":
        case "3":
            return StatusColorType.Error;
        case "-10":
        case "4":
            return StatusColorType.Warning;
        default:
            return StatusColorType.Success;
    }
};
